module.exports = __webpack_public_path__ + "img/girl-mobile.ac368dac.png";